import React from 'react';
import { IconButton, CardHeader } from '@material-ui/core';

import Card from 'components/StyledCard';
import CardContent from 'components/StyledCardContent';

import { CancelOutlined } from '@material-ui/icons';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';

import OverlaySpinner from 'components/spinners/OverlaySpinner';

import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

interface EditCardProps {
  editMode: boolean;
  isLoading: boolean;
  isValid?: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  title?: string;
  children: React.ReactNode;
  requireGlobalAdmin?: boolean;
}

const EditCard: React.FC<EditCardProps> = ({
  editMode,
  isLoading,
  isValid,
  onEdit,
  onSave,
  onCancel,
  title,
  children,
  requireGlobalAdmin,
}) => {
  const userAccess = useSelector(
    (state: ApplicationState) => state.isLoggedIn.userAccess,
  );

  return (
    <OverlaySpinner isLoading={isLoading}>
      <Card>
        <CardHeader
          title={title}
          action={
            editMode ? (
              <>
                <IconButton
                  onClick={onSave}
                  color="primary"
                  disabled={isValid !== undefined && isValid === false}
                >
                  <CheckIcon />
                </IconButton>
                <IconButton onClick={onCancel} color="secondary">
                  <CancelOutlined />
                </IconButton>
              </>
            ) : (
              (!requireGlobalAdmin || userAccess?.isGlobalAdmin) && (
                <IconButton onClick={onEdit} color="secondary">
                  <EditIcon />
                </IconButton>
              )
            )
          }
        ></CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </OverlaySpinner>
  );
};

export default EditCard;
